import React, { useState } from 'react';
import { MessageSquare, ChevronDown, ChevronUp } from 'lucide-react';

const INITIAL_SHOW = 4;

const AVATAR_GRADIENTS = [
  'from-[#9a51a0] to-[#f36f21]',
  'from-[#7f3df1] to-[#c84caa]',
  'from-[#4b79d9] to-[#8255d8]',
  'from-[#f36f21] to-[#f7b731]',
  'from-[#43b89c] to-[#4b79d9]'
];

const getGradient = (name) => {
  const index = (name?.charCodeAt(0) || 0) % AVATAR_GRADIENTS.length;
  return AVATAR_GRADIENTS[index];
};

const CommentList = ({ comments }) => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? comments : comments.slice(0, INITIAL_SHOW);
  const remaining = comments.length - INITIAL_SHOW;

  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <MessageSquare className="h-4 w-4 text-[#9a51a0]" />
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#9a51a0]">
          {comments.length} {comments.length === 1 ? 'Comment' : 'Comments'}
        </span>
      </div>

      <div className="divide-y divide-[#f0eaf8]">
        {visible.map((comment) => (
          <div key={comment.id} className="flex gap-3 py-4">
            <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br ${getGradient(comment.author)} text-sm font-bold text-white`}>
              {String(comment.author || 'U').slice(0, 1).toUpperCase()}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                <p className="text-sm font-bold text-[#241b37]">{comment.author}</p>
                <span className="text-[11px] text-[#9a87b0]">{comment.formattedDate}</span>
              </div>
              <p className="mt-1 text-sm leading-6 text-[#5b4e70]">{comment.text}</p>
            </div>
          </div>
        ))}
      </div>

      {!showAll && remaining > 0 && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl border border-dashed border-[#d7b3f4] bg-white py-3 text-sm font-semibold text-[#9a51a0] transition-colors hover:bg-[#faf6ff]"
        >
          <ChevronDown className="h-4 w-4" />
          Show {remaining} more comment{remaining > 1 ? 's' : ''}
        </button>
      )}

      {showAll && comments.length > INITIAL_SHOW && (
        <button
          type="button"
          onClick={() => setShowAll(false)}
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-2xl border border-dashed border-[#d7b3f4] bg-white py-3 text-sm font-semibold text-[#9a51a0] transition-colors hover:bg-[#faf6ff]"
        >
          <ChevronUp className="h-4 w-4" />
          Show less
        </button>
      )}
    </div>
  );
};

export default CommentList;
